import {
  FETCH_SCREENS_REQUEST,
  FETCH_SCREENS_SUCCESS,
  FETCH_SCREENS_FAILURE,
  FETCH_SCREEN_REPORT_FAILURE,
  FETCH_SCREEN_REPORT_SUCCESS,
  FETCH_SCREEN_REPORT_REQUEST,
} from "./actionTypes";

export const fetchScreensRequest = () => ({
  type: FETCH_SCREENS_REQUEST,
});

export const fetchScreensSuccess = (screens) => ({
  type: FETCH_SCREENS_SUCCESS,
  payload: screens,
});

export const fetchScreensFailure = (error) => ({
  type: FETCH_SCREENS_FAILURE,
  payload: error,
});

export const fetchScreenReportRequest = () => ({
  type: FETCH_SCREEN_REPORT_REQUEST,
});

export const fetchScreenReportSuccess = (data) => ({
  type: FETCH_SCREEN_REPORT_SUCCESS,
  payload: data,
});

export const fetchScreenReportFailure = (error) => ({
  type: FETCH_SCREEN_REPORT_FAILURE,
  payload: error,
});
